import { render } from "./CatalogNaming.vue?vue&type=template&id=2ac07f52"
import script from "./CatalogNaming.vue?vue&type=script&lang=js"
export * from "./CatalogNaming.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__